import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Chapter, FadeUp } from '../motion';
import { useT } from '../../i18n/LangContext';
import { useContent } from '../../data/useContent';

export default function BeforeAfterGrid() {
  const t = useT();
  const { BEFORE_AFTER } = useContent();

  return (
    <section data-testid="before-after-section" className="bg-coal py-24 md:py-32">
      <div className="container-site">
        <Chapter n={2} label={t['ch.beforeAfter']} />
        <FadeUp>
          <h2 className="max-w-3xl font-serif text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
            {t['ba.h2a']} <span className="italic text-gold">{t['ba.h2b']}</span>
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-silver">{t['ba.p']}</p>
        </FadeUp>

        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          {BEFORE_AFTER.map((item, i) => (
            <FadeUp key={item.img} delay={i * 0.1}>
              <figure data-testid={`ba-item-${i}`} className="group overflow-hidden rounded-xl shadow-2xl">
                <img src={item.img} alt={`${item.label} — Reverence Services, Ottawa`} loading="lazy"
                  className="photo-treat aspect-[16/9] w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
                <figcaption className="bg-ink px-5 py-4 text-sm font-bold text-white">{item.label}</figcaption>
              </figure>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.15} className="mt-12">
          <Link data-testid="ba-cta" to="/quote" className="gold-btn">
            {t['ba.cta']} <ArrowRight className="h-4 w-4" />
          </Link>
        </FadeUp>
      </div>
    </section>
  );
}
